// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"styles_profileImage__1bvXA","channelIcon":"styles_channelIcon__h0tm-"};